import { Box, Chip } from "@mui/material";
import type { ReactElement } from "react";

export type AppliedFilterChip<TKey extends string = string> = {
  key: TKey;
  label: string;
  color?: string;
  icon?: ReactElement;
};

type AppliedFilterChipsProps<TKey extends string> = {
  chips: AppliedFilterChip<TKey>[];
  onDelete: (key: TKey) => void;
  className?: string;
  ariaLabel?: string;
};

export function AppliedFilterChips<TKey extends string>({
  chips,
  onDelete,
  className = "",
  ariaLabel = "Applied filters",
}: AppliedFilterChipsProps<TKey>) {
  if (!chips.length) return null;

  return (
    <Box className={className} aria-label={ariaLabel}>
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          label={chip.label}
          icon={chip.icon}
          size="small"
          variant={chip.color ? "outlined" : "filled"}
          style={chip.color ? { backgroundColor: `${chip.color}20`, borderColor: chip.color, color: "#0f172a" } : undefined}
          onDelete={() => onDelete(chip.key)}
        />
      ))}
    </Box>
  );
}
